<template>
  <div class="edit-table">
    <el-form ref="form" :model="form" :rules="rules">
      <el-table border :data="form.tableData">
        <el-table-column
          label="序号"
          prop="index"
          type="index"
          width="60"
          align="center"
        />
        <el-table-column label="材料名称" align="center">
          <template slot="header">
            <span style="color:red;padding-right:4px">*</span>
            <span>材料名称</span>
          </template>
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'tableData.' + $index + '.materialName'"
              :rules="rules.materialName"
              class="m-t-18"
            >
              <el-input
                v-model="row.materialName"
                placeholder="请输入材料名称"
                maxlength="200"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="材料类型" align="center" min-width="120">
          <template slot="header">
            <span style="color:red;padding-right:4px">*</span>
            <span>材料类型</span>
          </template>
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'tableData.' + $index + '.materialType'"
              :rules="rules.materialType"
              class="m-t-18"
            >
              <el-radio-group v-model="row.materialType">
                <el-radio
                  v-for="item in materialTypeDictArray"
                  :key="item.value"
                  :label="item.value"
                >{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="是否必填" align="center">
          <template slot="header">
            <span style="color:red;padding-right:4px">*</span>
            <span>是否必填</span>
          </template>
          <template slot-scope="{ row, $index }">
            <el-form-item
              :prop="'tableData.' + $index + '.isRequired'"
              :rules="rules.isRequired"
              class="m-t-18"
            >
              <el-radio-group v-model="row.isRequired">
                <el-radio
                  v-for="item in isRequiredDictArray"
                  :key="item.value"
                  :label="item.value"
                >{{ item.formLabel }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="填写说明" align="center">
          <template slot-scope="{ row }">
            <el-form-item class="m-t-18">
              <el-input
                v-model="row.remark"
                placeholder="请输入填写说明"
                maxlength="200"
              />
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              size="small"
              class="text-danger"
              @click="deleteRow(row, $index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <div v-if="showAddButton" class="table-btn flex-center m-t-16" @click="add">
      <i class="el-icon-plus"></i> 添加
    </div>

    <!--<el-button @click="validateTable">校验</el-button>-->
  </div>
</template>

<script>
// 方法
import { cloneDeep } from 'lodash'
import {
  otherMaterialRequirementDict,
  otherMaterialTypeDict
} from '@/dictionary/project/common'

/**
 * @Description: 其他材料要求编辑表格
 */
export default {
  name: 'EditTable',

  props: {
    table: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      form: {
        tableData: []
      },
      rules: {
        materialName: [
          { required: true, message: '请输入材料名称', trigger: 'blur' }
        ],
        materialType: [
          { required: true, message: '请选择材料类型', trigger: 'change' }
        ],
        isRequired: [
          { required: true, message: '请选择是否必填', trigger: 'change' }
        ]
      },
      tableData: [],

      // 材料类型
      materialTypeDictArray: otherMaterialTypeDict.array,

      // 是否必填
      isRequiredDictArray: otherMaterialRequirementDict.array
    }
  },

  computed: {
    // 是否显示添加按钮
    showAddButton() {
      // 当表格数据量>=20的时候，隐藏
      return this.form.tableData.length < 20
    }
  },

  watch: {
    table: {
      handler(val) {
        if (val?.length > 0) this.form.tableData = cloneDeep(val)
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    /**
     * 添加
     */
    add() {
      this.form.tableData.push({
        materialName: '',
        materialType: '',
        isRequired: '',
        remark: ''
      })
    },

    /**
     * 删除当前行
     */
    deleteRow(row, index) {
      this.form.tableData.splice(index, 1)
    },

    /**
     * 校验表格
     */
    validateTable() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            reject(new Error('请按要求填写表格'))
            return
          }

          resolve(valid)
          console.log('校验通过', this.form.tableData)
          this.$emit('update:table', cloneDeep(this.form.tableData))
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-btn {
  height: 32px;
  border: 1px dashed $primary-color;
  color: $primary-color;
  font-size: 14px;
  cursor: pointer;
  background-color: $white-background-color;
  border-radius: 4px;

  i {
    @include text-bold;
    font-size: 14px;
    margin-right: 4px;
  }

  &:hover {
    opacity: 0.8;
  }
}
::v-deep {
  .el-table--small {
    font-size: 14px;
  }
}
</style>
